// extracted by mini-css-extract-plugin
export default {"container":"AvatarMobile_container__p7UjC","avatarCancel":"AvatarMobile_avatarCancel__qHYH-"};